<template>
  <div style="display:flex; flex-direction: column; align-items: center; width: 100%">


    <img :src="imageUrl" width="800" style="margin-top: 10px; "></img>

    <div style="display: flex; flex-direction: row">
      <el-button type="primary" style="width: 120px; background-color: darkcyan; margin-top: 20px;" @click="goback()">
        返回
      </el-button>
      <el-button v-if="canDownload" type="primary" style="width: 120px; background-color: darkcyan; margin-top: 20px;"
                 @click="download()">下载pdf证书
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "certImage",

  data() {
    return {
      imageUrl: null,
      canDownload: false,
      userInfo: null,
    }
  },
  mounted() {
    console.log(this.$route.params, 999)
    this.imageUrl = this.$route.params.imageUrl
    this.canDownload = this.$route.params.canDownload == "true"
    this.userInfo = this.$route.params.userInfo
    // this.imageUrl = "https://x.moshushi.pro/files/certImagesPC/123_432423443242342_Z.jpg"
  },
  methods: {

    goback() {
      this.$router.go(-1)
    },

    download() {
      this.openFullScreen2()
      this.$axios.get(window.SITE_CONFIG['baseUrl'] + `/custom/genCert/singleDownloadCert`, {
        params: {
          "classCode": this.userInfo.bjbh,
          "sfzh": this.userInfo.sfzh,
        }
      }).then(res => {
        console.log(res, 99990)
        this.closeFullScreen()
        if (res.data.code == 0) {

          this.downloadFile(res.data.data)

        } else {
          this.$message.error(res.data.msg)
        }
        console.log(res)
      }).catch(error =>
        //请求失败，触发catch中的函数 可省略
        console.log(error)
      )
    },

    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: '证件生成中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

    },

    closeFullScreen() {
      this.loading.close();
    },


    async downloadFile(filePath) {

      // const filename = filePath.split('/').pop(); // 文件名
      const filename = filePath.substr(filePath.lastIndexOf('/') + 1, filePath.length); // 文件名

      // 创建隐藏的可下载链接
      const element = document.createElement('a');
      element.setAttribute('href', filePath);
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);

      // 点击下载
      element.click();

      // 移除隐藏元素
      document.body.removeChild(element);


    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/certImage.vue